export class InvoiceGeneration {
  periodType?: number | null;
  office?: string | null;
  startDate?: Date | null;
  endDate?: Date | null;
  clientNumber?: number | null;
  projectNumber?: number | null;
  subcode?: number | null;
  altSubcode?: number | null;
  backupRate?: number | null;
  backupPercentage?: number | null;
  assignedBackup?: number | null;
  createdByNumber?: number | null;
  createdByName?: string | null;
  invoiceDate?: Date | null;
}


// WEBPACK FOOTER //
// ./src/components/project-billing/models/InvoiceGeneration.ts